import { piersUrl } from 'endpoints';
import { fetch } from '@nackle/umbrella';

export function getUserMarketplace( accessToken, companyId, personId ) {
    return fetch( piersUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${ accessToken }`
        },
        body: JSON.stringify(
            {
                query: `query($companyId: String!, $personId: String!) {
                    person(companyId: $companyId, personId: $personId) {
                        marketplace {
                            menuItems {
                                displayOrder
                                pageType
                                colorLogo
                                outlineThickLogo
                            }
                        }
                        solutions {
                            solutionIdentity
                        }

                    }
                }`,
                variables: {
                    companyId,
                    personId
                }
            }
        )
    } ).then( async response => await response.json() );
}